

import React, { useState } from 'react'
import { useHistory } from "react-router-dom"; 
import Sidebar from '../layout/sidebar';
import Header from '../layout/header';


export default function MainLayout({ children }) {
    const history = useHistory();
    const [overlay, setOverlay] = useState(false)
    const MenuToggle = () => {
        setOverlay(!overlay)
    }
    const RemoveOverlay = () => {
        setOverlay(false)
    }
    return (
        <React.Fragment>
            <div className="container-fluid">
                {overlay ? <span className="popup_overlay" onClick={RemoveOverlay}></span> : ''}
                <Header history={history} MenuToggle={MenuToggle}></Header>
                <div className={`dashboard_wrapper ${overlay ? 'active' : ''}`}>
                    <Sidebar history={history}></Sidebar>
                    {children}
                </div>
            </div>
        </React.Fragment>
    )
}



// function MainLayout({children, history}) {
// const [overlay,setOverlay] = useState(false)
// const MenuToggle = () => {
// setOverlay(true)
// }

//    const RemoveOverlay = () => {
//     setOverlay(false)
//     }
//     return (
//         <React.Fragment>            
//             <div className="container">
//             {overlay ? <span className="popup_overlay" onClick={RemoveOverlay}></span> : '' }
//                 <Header history={history} MenuToggle={MenuToggle}></Header>
//                 <div className={`dashboard_wrapper ${overlay ? 'active' : ''}`}>
//                     <Sidebar history={history}></Sidebar>
//                     {children}
//                 </div>
//             </div>
//         </React.Fragment>
//     )
// }
// export default MainLayout;